import queryString from 'query-string';
import { apiFetch } from './utils/api';

// const mockedPortfolios = require('./mocks/v3/portfolios.json');

export const portfolios = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = queryString.stringify(args, { arrayFormat: 'comma' });
    const url = `/v3/portfolio/portfolios?${query}`;

    const { body, headers } = await apiFetch(url, {
      ...options,
    });

    return [body, headers];
  },
};
